// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16jKy","left":"styles_left__1fvum","desktopActions":"styles_desktopActions__125qP","title":"styles_title__3pdmY"};